import script from "./TrendSparkline.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendSparkline.vue?vue&type=script&setup=true&lang=js"

import "./TrendSparkline.vue?vue&type=style&index=0&id=f36fc022&scoped=true&lang=scss"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f36fc022"]])

export default __exports__